// src/components/Footer.jsx
import React from "react";
import { FaFacebook, FaInstagram, FaTiktok } from "react-icons/fa";

function Footer() {
  const currentYear = 2025;

  return (
    <footer className="mt-16 py-5 px-8 bg-white/80 border-t border-gray-200 text-gray-700 text-center text-sm">
      <div className="flex items-center justify-center gap-4 mb-3">
        <a
          href="https://www.facebook.com/share/1BAA91z5eG/?mibextid=wwXIfr"
          target="_blank"
          rel="noopener noreferrer"
          className="text-green-600 hover:text-green-700 transition"
          title="Facebook"
        >
          <FaFacebook size={20} />
        </a>
        <a
          href="https://www.instagram.com/pt.soney_raya"
          target="_blank"
          rel="noopener noreferrer"
          className="text-green-600 hover:text-green-700 transition"
          title="Instagram"
        >
          <FaInstagram size={20} />
        </a>
        <a
          href="https://www.tiktok.com/@pt.soneyraya"
          target="_blank"
          rel="noopener noreferrer"
          className="text-green-600 hover:text-green-700 transition"
          title="TikTok"
        >
          <FaTiktok size={20} />
        </a>
      </div>

      <p className="font-semibold text-gray-800 mb-1">
        Soney Raya — Mitra Terpercaya Keamanan Anda.
      </p>
      <p className="text-gray-600">
        &copy; {currentYear} Hak Cipta Dilindungi. | Ditenagai oleh Inovasi.
      </p>

      <div className="mt-3">
        <a
          href="/privacy"
          className="text-green-600 hover:text-green-700 transition font-medium"
        >
          Kebijakan Privasi
        </a>
      </div>
    </footer>
  );
}

export default Footer;
